import React, { useCallback } from "react";
import { Form, Button, Image } from "semantic-ui-react";
import { useFormik } from "formik";
import { useDropzone } from "react-dropzone";
import { initialValues, validationSchema } from "./PartnerForm.form";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";

export function PartnerFormOne(props) {
  const { updateFormData, formData, nextStep, user } = props;
  const { t } = useTranslation(["partners", "common"]);

  const formik = useFormik({
    initialValues: initialValues(user.user, formData),
    validationSchema: validationSchema(t),
    validateOnChange: false,
    onSubmit: async (values) => {
      try {
        updateFormData(values);
        nextStep(); // Avanza al siguiente paso
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: "top-center",
          autoClose: false,
          closeOnClick: true,
        });
      }
    },
  });

  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        const validMimeTypes = ["image/jpeg", "image/png"];
        if (validMimeTypes.includes(file.type)) {
          formik.setFieldValue("miniature", URL.createObjectURL(file));
          formik.setFieldValue("file", file);
        } else {
          console.log("Tipo de archivo no soportado:", file.type);
        }
      }
    },
    [formik],
  );

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/jpeg": [".jpeg", ".jpg"],
      "image/png": [".png"],
    },
    onDrop,
    multiple: false,
  });

  const getMiniature = () => {
    if (formik.values.file) {
      return formik.values.miniature;
    } else if (formik.values.miniature) {
      // si viene del servidor es que estamos actualizando
      return `${formik.values.miniature}`;
    }
    return null;
  };
  return (
    <>
      <ToastContainer />
      <Form onSubmit={formik.handleSubmit}>
        <div className="post-form__miniature" {...getRootProps()}>
          <input {...getInputProps()} />
          {getMiniature() ? (
            <Image size="small" src={getMiniature()} />
          ) : (
            <div>
              <span> {t("partners:form.logoLabel")} </span>
            </div>
          )}
        </div>
        <Form.Input
          type="text"
          icon="user"
          iconPosition="left"
          name="name"
          placeholder={t("partners:form.namePlaceholder")}
          onChange={formik.handleChange}
          value={formik.values.name}
          error={
            formik.errors.name
              ? { content: formik.errors.name, pointing: "above" }
              : null
          }
        />
        <Form.Input
          type="text"
          icon="barcode"
          iconPosition="left"
          name="code"
          placeholder={t("partners:form.codePlaceholder")}
          onChange={formik.handleChange}
          value={formik.values.code || ""}
          error={
            formik.errors.code
              ? { content: formik.errors.code, pointing: "above" }
              : null
          }
        />
        <Form.Input
          type="text"
          icon="phone"
          iconPosition="left"
          name="mobile"
          placeholder={t("partners:form.mobilePlaceholder")}
          onChange={formik.handleChange}
          value={formik.values.mobile}
          error={
            formik.errors.mobile
              ? { content: formik.errors.mobile, pointing: "above" }
              : null
          }
        />
        <Form.Input
          type="text"
          name="email"
          placeholder={t("partners:form.emailPlaceholder")}
          onChange={formik.handleChange}
          value={formik.values.email}
          error={
            formik.errors.email
              ? { content: formik.errors.email, pointing: "above" }
              : null
          }
        />
        <Form.Input
          type="url"
          icon="world"
          iconPosition="left"
          name="socialNetworks.website"
          placeholder={t("partners:form.websitePlaceholder")}
          onChange={formik.handleChange}
          value={formik.values.socialNetworks?.website || ""}
          error={
            formik.errors.socialNetworks?.website
              ? {
                  content: formik.errors.socialNetworks.website,
                  pointing: "above",
                }
              : null
          }
        />
        <div className="formgroup">
          <Form.Group>
            <Button
              type="submit"
              color="green"
              style={{ width: "33.3333%", marginLeft: "33.3333%" }}
            >
              {t("common:actions.saveChanges")}
            </Button>
          </Form.Group>
        </div>
      </Form>
    </>
  );
}
